"use client"

import { useState, useCallback } from "react"

export const useMobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev)
  }, [])

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false)
  }, [])

  const openMenu = useCallback(() => {
    setIsMenuOpen(true)
  }, [])

  return {
    isMenuOpen,
    toggleMenu,
    closeMenu,
    openMenu,
  }
}
